import {useTranslation} from "react-i18next";
import {useToast} from "../../modules/layout/components/ToastContext";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {IAuditLog,IAuditActionType, IAxiosGetResponse} from "../../interfaces/IUtilities";
import {getById} from "../_request";
import AppBreadcrumb from "../../modules/layout/components/AppBreadcrumb";
import Loader from "../../modules/layout/components/Loader";
import {
    AuditActionTypeEnumText,
    AuditEntityTypeEnumText,
    AuditSourceSystemEnumText
} from "../../helpers/EnumeratorHelper";
import BackButton from "../../modules/layout/components/BackButton";
import {formatDateTime} from "../../helpers/DateTimeHelper";

const AuditLogDetails = () => {

    const { t } = useTranslation();
    const { showToast } = useToast();
    const { id } = useParams();
    const [auditLog, setAuditLog] = useState({} as IAuditLog);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let result = await getById("/api/auditlogs/", id!);
                let respStatus = result?.status || result?.response.status;

                if (respStatus === 200) {
                    setAuditLog(result.data as IAuditLog);
                    setLoading(false);
                }
                else if (respStatus === 403) {
                    navigate("/error/403");
                }
                else if (respStatus === 401) {
                    navigate("/auth/login");
                }
                else if (respStatus === 500) {
                    navigate("/error/500");
                }
                else {
                    throw new Error(t('StatusCode', {code: String(respStatus)}));
                }
            } catch (error) {
                setLoading(false);
                console.log(t('ConnectionError', {error: String(error)}));
                showToast(t('ConnectionError', {error: String(error)}), 'error');
                navigate("/audit-logs/list");
            }
        }
        fetchData();

    }, [id]);


    return (
        <div className="container mt-4 gg-container-card">
            <AppBreadcrumb
                items={[
                    {title: t("Home"), href: "/"},
                    {title: t("AuditLogsList"), href: "/audit-logs/list"},
                    {title: t('LogId', { id }), },
                ]}/>

            <h3>{ t('AuditLogDetails')}</h3>

            {loading && (<Loader />)}
            
            <div className="card">
                <div className="card-body">
                    <p><strong>{ t('UserId') }:</strong> {auditLog.userId}</p>
                    <p><strong>{t('UserName')}:</strong>{" "}
                        {(auditLog.userName && auditLog.userName.length > 0) ? 
                            auditLog.userName :
                            <i className="text-danger">{t('UserRemoved')}</i>
                        }
                    </p>
                    <p><strong>{t('FullName')}:</strong>{" "}
                        {(auditLog.fullName && auditLog.fullName.length > 0) && auditLog.fullName}
                    </p>
                    {auditLog.actionType !== IAuditActionType.Login && auditLog.actionType !== IAuditActionType.Verify && (
                        <p><strong>{t('ChangedBy')}:</strong> {auditLog.actorFullName || auditLog.actorUserName}</p>
                    )}
                    <p><strong>{ t('IpAddress') }:</strong> {auditLog.ipAddress}</p>
                    <p><strong>{ t('ClientAppId')}:</strong> {auditLog.clientAppId}</p>
                    <p><strong>{ t('ActionType') }:</strong> {AuditActionTypeEnumText[auditLog.actionType]}</p>
                    <p><strong>{ t('EntityType') }:</strong> {AuditEntityTypeEnumText[auditLog.entityType]}</p>
                    <p><strong>{ t('SourceSystem') }:</strong> {AuditSourceSystemEnumText[auditLog.sourceSystem]}</p>
                    <p><strong>{ t('Reason')}:</strong> {auditLog.reason}</p>
                    <p><strong>{ t('Timestamp')}:</strong> {formatDateTime(auditLog.timestamp)}</p>
                    <p><strong>{ t('CurrentStage')}:</strong> {auditLog.currentStage}</p>
                    <div className="mb-3"><strong>{ t('Changes')}:</strong> 
                    { auditLog.changes ? 
                    <pre className="bg-light p-3 border rounded">
                        {JSON.stringify(JSON.parse(auditLog.changes), null, 2)}
                    </pre> : <></>
                    }</div>
                    <p><strong>{ t('ErrorMessage')}:</strong> {auditLog.errorMsg}</p>
                    <div className="mb-3"><strong>{ t('OldValue')}:</strong> 
                    { auditLog.oldValue ? 
                    <pre className="bg-light p-3 border rounded">
                        {JSON.stringify(JSON.parse(auditLog.oldValue), null, 2)}
                    </pre> : <></>
                    }</div>
                    <div className="mb-3"><strong>{ t('NewValue')}:</strong> 
                    { auditLog.newValue ? 
                    <pre className="bg-light p-3 border rounded">
                        {JSON.stringify(JSON.parse(auditLog.newValue), null, 2)}
                    </pre> : <></>
                    }
                    </div>
                </div>
                <div className="card-footer bg-transparent">
                    <BackButton goTo={"/audit-logs/list"}/>
                </div>
            </div>

        </div>
    )
}
export default AuditLogDetails;